import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// variant: "dark" (image bg) | "orange" (solid brand)
export default function InnerHero({
    title,
    subtitle,
    image,
    variant = "dark",
    crumb,
    children,
}) {
    const orange = variant === "orange";
    return (
        <section
            data-testid="inner-hero"
            className={`relative overflow-hidden ${orange ? "bg-brand" : "bg-ink"}`}
        >
            {!orange && image && (
                <>
                    <img
                        src={image}
                        alt=""
                        className="absolute inset-0 h-full w-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/80 to-ink/30" />
                </>
            )}

            <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-40 pb-20 lg:pt-48 lg:pb-24">
                <div className="max-w-2xl">
                    <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-white/80">
                        <Link to="/" className="hover:text-white">
                            Inicio
                        </Link>
                        <ChevronRight className="h-3.5 w-3.5 text-brand" />
                        <span className={orange ? "text-white" : "text-brand"}>
                            {crumb}
                        </span>
                    </div>
                    <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase leading-[0.95] text-white">
                        {title}
                    </h1>
                    {subtitle && (
                        <p className="mt-5 max-w-lg text-base sm:text-lg text-white/80">
                            {subtitle}
                        </p>
                    )}
                </div>
                {children}
            </div>
        </section>
    );
}
